import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import WebService from "./pages/services/WebService";
import SNSService from "./pages/services/SNSService";
import MarketingService from "./pages/services/MarketingService";
import ConsultingService from "./pages/services/ConsultingService";
import TikTokLiveService from "./pages/services/TikTokLiveService";
import GlobalExpansion from "./pages/services/GlobalExpansion";
import JapanMarketEntry from "./pages/services/JapanMarketEntry";
import GlobalBusiness from "./pages/GlobalBusiness";
import Pricing from "./pages/Pricing";
import Company from "./pages/Company";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import News from "./pages/News";
import NewYearCampaignPage from "./pages/NewYearCampaignPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/web" element={<WebService />} />
          <Route path="/services/sns" element={<SNSService />} />
          <Route path="/services/marketing" element={<MarketingService />} />
          <Route path="/services/consulting" element={<ConsultingService />} />
          <Route path="/services/tiktok-live" element={<TikTokLiveService />} />
          <Route path="/services/global-expansion" element={<GlobalExpansion />} />
          <Route path="/services/japan-market-entry" element={<JapanMarketEntry />} />
          <Route path="/global-business" element={<GlobalBusiness />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/company" element={<Company />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/news" element={<News />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/new-year-campaign" element={<NewYearCampaignPage />} />
        </Routes>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
